import qs from 'query-string';

import { onboarding } from '@services';

import { IdentificationRequestStatus } from '@models/IdentificationRequests.model';

interface IChangeChatStatus {
  threadId: string;
  status: IdentificationRequestStatus;
}

const changeChatStatus = async ({
  status,
  threadId,
}: IChangeChatStatus): Promise<void> => {
  const query = {
    status,
    threadId,
  };

  const queryString = qs.stringify(query);

  await onboarding.patch(`/api/v1/chat/thread?${queryString}`);
};

export { changeChatStatus };
